import React from 'react';
import { motion } from 'framer-motion';
import { Hero } from '../components/home/Hero';
import { BannerCarousel } from '../components/home/BannerCarousel';
import { HeroSearch } from '../components/home/HeroSearch';
import { PromoPair } from '../components/home/PromoPair';
import { SpecialSalesPair } from '../components/home/SpecialSalesPair';
import { CompareCampaign } from '../components/home/CompareCampaign';
import { CreditCta } from '../components/home/CreditCta';
import { UsedStockCta } from '../components/home/UsedStockCta';
import { FeaturedCarousel } from '../components/home/FeaturedCarousel';
import { Reveal } from '../components/ui/Reveal';
const steps = [{
  title: 'Explorá y compará',
  text: 'Todas las marcas en un mismo catálogo. Elegí hasta 3 unidades y comparalas punto por punto.'
}, {
  title: 'Simulá con condiciones reales de cada unidad',
  text: 'El simulador carga la tasa, los plazos y el anticipo que corresponden a la versión elegida.'
}, {
  title: 'Decidí con un asesor',
  text: 'Un asesor comercial revisa tu caso y te acompaña hasta la entrega de tu 0 km.'
}];
export function Home() {
  return <>
      <Hero data-id="element-1290" data-mp="2vyhwodlw1axm" />
      <Reveal data-id="element-1291" data-mp="2vvvoqcv34tev">
        <BannerCarousel data-id="element-1292" data-mp="2qyby0dh7ao61" />
      </Reveal>
      <Reveal className="container-x pb-4" data-id="element-1293" data-mp="2qxal03gmjrlo">
        <HeroSearch data-id="element-1294" data-mp="2r0g8je9lulfa" />
      </Reveal>
      <Reveal data-id="element-1295" data-mp="2mxrzb5gzbchs">
        <PromoPair data-id="element-1296" data-mp="2mw8jffz8j3gj" />
      </Reveal>
      <Reveal data-id="element-1297" data-mp="2mz37rildd8f8">
        <SpecialSalesPair data-id="element-1298" data-mp="2hxxbjasi330y" />
      </Reveal>
      <Reveal data-id="element-1299" data-mp="2hyyvk4rhuzut">
        <CompareCampaign data-id="element-1300" data-mp="2hzi3csnfk7v4" />
      </Reveal>
      <Reveal data-id="element-1301" data-mp="2d776xzrwf47b">
        <UsedStockCta data-id="element-1302" data-mp="2d6oz05vvj1jk" />
      </Reveal>

      <FeaturedCarousel data-id="element-1303" data-mp="2d5mcea5l3l9g" />

      <section className="container-x py-14" aria-labelledby="how-title" data-id="element-1304" data-mp="2d5dxydttc7w5">
        <Reveal data-id="element-1305" data-mp="288nle0h7vufh">
          <h2 id="how-title" className="text-metal max-w-xl font-display text-2xl font-black sm:text-3xl" data-id="element-1306" data-mp="2861dfzqezcwq">
            Comparar marcas, evaluar alternativas y decidir acompañado.
          </h2>
        </Reveal>
        <ol className="mt-8 grid gap-8 border-t border-line pt-8 md:grid-cols-3" data-id="element-1307" data-mp="1z98w34csdpwk">
          {steps.map((s, i) => <motion.li key={s.title} className="flex gap-4" initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: i * 0.06
        }} data-id="element-1308" data-mp="1kkyzb54u5fom" data-mpi={i}>
              <span className="text-glow font-display text-4xl font-black text-neon" data-id="element-1309" data-mp="1fm5xi9ywvd4a">{i + 1}</span>
              <div data-id="element-1310" data-mp="23bqieyemkkg7">
                <h3 className="font-semibold text-silver-hi" data-id="element-1311" data-mp="23dbckmx121dj">{s.title}</h3>
                <p className="mt-1 text-sm text-mist" data-id="element-1312" data-mp="289072bu6ws2z">{s.text}</p>
              </div>
            </motion.li>)}
        </ol>
      </section>

      <Reveal data-id="element-1313" data-mp="1yki53ra6cexr">
        <CreditCta data-id="element-1314" data-mp="1yjyn6akixqjq" />
      </Reveal>
    </>;
}